import React, { useState, useEffect } from "react";

const MenuButcher = ({ 
    subtitle = "Kinder's Catering",
    body = "Legendary BBQ. Served your way.",
    image = "/images/menu-butcher.jpg",
    imageMobile = "/images/menu-butcher-mobile.jpg"
}) => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1023px)');
    setIsMobile(mediaQuery.matches);

    const handleResize = (e) => setIsMobile(e.matches);
    mediaQuery.addListener(handleResize);

    return () => mediaQuery.removeListener(handleResize);
  }, []);

  // Select the appropriate image based on screen size
  const currentImage = isMobile && imageMobile ? imageMobile : image;

  return (
    <div className="catering-hero-area">
      <div className="content-space-100" />
      
      {/* Content Container */}
      <div className="catering-content-wrapper">
        {/* Headlines Content */}
        <div className="columns catering-headlines is-flex is-flex-direction-column">
          {/* Main Title */}
          {subtitle && (
            <div className="px-6 py-0 column is-6 is-offset-3">
              <h2 className="m-0 p-0 subtitle colorBlack is-align-center">
                {subtitle}
              </h2>
            </div>
          )}

          {/* Body */}
          {body && (
            <div className="px-6 py-0 mb-6 column is-8 is-offset-2">
              <p className="m-0 p-0 big colorBlack is-align-center">
                {body}
              </p>
            </div>
          )}

          {/* Image */}
          {currentImage && (
            <div className="mt-4 mb-6 column is-12">
              <figure className="image is-fullwidth" style={{ height: '100%', margin: 0 }}>
                <img 
                  src={currentImage} 
                  alt="Our butcher and deli counter"
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover',
                    objectPosition: 'center'
                  }}
                />
              </figure>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MenuButcher;